import Notification from '@/components/notice/Notification'

let notice = [{
  path: '/notice',
  name: 'Notification',
  component: Notification
}]

export default notice



// WEBPACK FOOTER //
// ./src/router/notice.js